import actions from './actions.js';
import mutations from './mutations.js';
import stateDefaults from './state.js';

import StateMachine from '@rankers/lib/state_machine';

// A FACTORY, not a module singleton — the experience profile's markup is re-injected each
// time a pane opens, and the framework has no unsubscribe, so a shared machine would
// accumulate subscribers on every open (see the AccountPanel's machine for the same note).
// State is spread fresh each call so instances never share the imported defaults object.
export default function createSuggestionPanelStateMachine() {
  return new StateMachine({
    name: 'SuggestionPanel',
    actions,
    mutations,
    state: { ...stateDefaults, files: [] },
  });
}
